import { useState } from "react";
import api from "../logic/axios";
import {
  Heading,
  Text,
  Input,
  Button,
  Box,
  VStack,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";

export const SignInForm = ({ onLogin }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/auth/login", {
        login,
        password,
      });

      localStorage.setItem("token", response.data.token);

      onLogin(response.data.user);
    } catch (err) {
      if (err.response?.status === 401) {
        setError("Invalid login or password");
      } else {
        setError("Something went wrong. Try again.");
      }
    }
  };

  return (
    <Box
      className="flex items-center justify-center min-h-screen"
      bg="gray.900"
      color="gray.100"
    >
      <form
        onSubmit={handleSubmit}
        autoComplete="on"
        className="w-full max-w-lg"
      >
        <Box
          bg="gray.800"
          p={10}
          rounded="2xl"
          shadow="2xl"
          border="1px solid"
          borderColor="gray.700"
        >
          <VStack spacing={8} align="stretch">
            <Box textAlign="center">
              <Heading size="lg" mb={2} color="teal.300">
                Welcome Back
              </Heading>
              <Text fontSize="sm" color="gray.400">
                Please sign in to your account
              </Text>
            </Box>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.300">
                Login
              </FormLabel>
              <Input
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                placeholder="Enter your login"
                focusBorderColor="teal.400"
                rounded="lg"
                size="lg"
                bg="gray.700"
                color="gray.100"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.300">
                Password
              </FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                focusBorderColor="teal.400"
                rounded="lg"
                size="lg"
                bg="gray.700"
                color="gray.100"
              />
            </FormControl>

            {error && (
              <Text color="red.400" fontSize="sm" textAlign="center">
                {error}
              </Text>
            )}

            <Button
              type="submit"
              colorScheme="teal"
              size="lg"
              rounded="lg"
              _hover={{ bg: "teal.500" }}
            >
              Sign In
            </Button>
          </VStack>
        </Box>
      </form>
    </Box>
  );
};
